import type { ISODateTime } from './ISODateTime';

export type ByggMoteromCalendarEntry = {
    accountId: string;
    end: ISODateTime;
    name: string;
    start: ISODateTime;
    status: string;
    subject: string;
};

export type ByggMoteromCalendarEntryConverted = {
    id: string;
    title: string;
    start: Date;
    end: Date;
    name: string;
};

export const convertByggMoteromCalendarEntry = (
    entry: ByggMoteromCalendarEntry,
): ByggMoteromCalendarEntryConverted => ({
    id: entry.accountId,
    title: entry.subject,
    start: new Date(entry.start),
    end: new Date(entry.end),
    name: entry.name,
});
